
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {TimelineLite, Timeline} from "gsap";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {WinterHoardTextStyles} from "../config/WinterHoardTextStyles";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class BuffaloFreespinMultiplierView extends BaseView {

    private _meterWrapper:PIXI.Sprite;
    private _meters:PIXI.Sprite [] = [];
    private _indicatorSprites:PIXI.Sprite [] = [];

    private _mpLabels: PIXI.Text [] = [];

    constructor() {
        super();
    }

    protected initAnimations():void {
        //this.position.set(0, 11)

        this._meterWrapper = this.createSymMeter();

        StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_COUNTERS.name).addChild(this);
        this.addChild(this._meterWrapper);
        this.visible = false;
    }

    protected createSymMeter():PIXI.Sprite {
        const wrapper:PIXI.Sprite = new PIXI.Sprite();

        [5,4,3,2,1].forEach((symValue:number, ind:number) => {
            const symSprite:PIXI.Sprite = new PIXI.Sprite(); //new PIXI.Sprite(GameResources.getTextures("indicatorM" + symValue)[0]);
            symSprite.name = "M" + symValue;

            [1, 2, 3, 4, 5].forEach((indicator:number, index:number) => {
                const sprite:PIXI.Sprite = new PIXI.Sprite(); //new PIXI.Sprite(GameResources.getTextures("tmpEnergy")[0]);
                //sprite.tint = 0xCCCCCC;
                sprite.name = "indicator" + indicator;
                sprite.width = 60;
                sprite.height = 60;
                sprite.alpha = 0.6;
                sprite.visible = false;

                switch(index) {
                    case 0:
                        sprite.y = 120;
                        sprite.x = 15;
                        break;
                    case 1:
                        sprite.y = 120;
                        sprite.x = 100;
                        break;
                    case 2:
                        sprite.y = 40;
                        sprite.x = -10;
                        break;
                    case 3:
                        sprite.y = 40;
                        sprite.x = 130;
                        break;
                    case 4:
                        sprite.y = -15;
                        sprite.x = 60;
                        break;
                }

                symSprite.addChild(sprite);
                this._indicatorSprites.push(sprite);
            });

            const mpText:PIXI.Text = new PIXI.Text((ind === 0 || ind === 4)? "" : "", WinterHoardTextStyles.FREESPIN_COUNTER);
            mpText.anchor.set(0.5, 0.5);
            mpText.position.set(50, 130);
            this._mpLabels.push(mpText);
            symSprite.addChild(mpText);

            const m1Sprite:PIXI.Sprite = new PIXI.Sprite(); //new PIXI.Sprite(GameResources.getTextures("indicatorM1")[0]);
            m1Sprite.name = "M1";
            m1Sprite.visible = false;


            this._meters.push(symSprite);
            wrapper.addChild(symSprite);
            symSprite.addChild(m1Sprite);
        });

        return wrapper;
    }

    protected onResize(resizeData: IResizeData): void {
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._meterWrapper.scale.set(0.65, 0.65);
            this._meterWrapper.x = -160;
            this._meterWrapper.y = 480;

            const yOffset:number = 10;
            this._meters.forEach((symSprite:PIXI.Sprite, index:number) => {
                symSprite.y = index * -symSprite.height + yOffset;
                symSprite.x = 0;
            })
        }
        else {
            this._meterWrapper.scale.set(0.7, 0.7);
            this._meterWrapper.x = 60;
            this._meterWrapper.y = -40;

            const xOffset:number = -15;
            this._meters.forEach((symSprite:PIXI.Sprite, index:number) => {
                symSprite.x = index * symSprite.width + xOffset;
                symSprite.y = 0;
            })
        }
    }

    public updateData(collectedBefore:number, collectedAfter:number, collectPositions:boolean [][], symbolMultipliers:{
        M1:number,
        M2:number,
        M3:number,
        M4:number,
        M5:number
    }, mode:string = "FREESPIN_MULTIPLIER", isRestore:boolean = false, fsLeft:number = 0):Timeline [] {
        const tlArr:Timeline [] = [];

        const energyCollectedBefore:number = collectedBefore;
        const energyCollectedAfter:number = collectedAfter;
        const energyCollectPositions:boolean [][] = collectPositions;

        const updateCount:number = collectedAfter - collectedBefore;
        let nrOfCollectPositions:number = 0;

        energyCollectPositions.forEach((arr) => {
            arr.forEach((bool) => {
                if(bool) {
                    nrOfCollectPositions++;
                }
            });
        });

        /*console.log("UPDATE COUNT: " + updateCount);
        console.log("NUMBER OF COLLECT POSITIONS: " + nrOfCollectPositions);*/

        // TODO: The purpose here is to validate model data with view update,
        //  and only return a list with paused timelines that will be injected to the presentation timeline.

        // Validation and update

        //const tl:TimelineLite = new TimelineLite({paused:true});


        /*const symMps:{M1:number, M2:number, M3:number, M4:number, M5:number} = {
            M1: symbolMultipliers.M1 || 1,
            M2: symbolMultipliers.M2 || 1,
            M3: symbolMultipliers.M3 || 1,
            M4: symbolMultipliers.M4 || 1,
            M5: symbolMultipliers.M5 || 1,
        };*/

        // Validation and update
        if(energyCollectedBefore < energyCollectedAfter && energyCollectedAfter <= 35) {
            for(let i = energyCollectedBefore; i < energyCollectedAfter; i++) {
                const tl:Timeline = new TimelineLite({paused:true});
                tl.add(() => {
                    //if(this._indicatorSprites[i]) {
                        //this._indicatorSprites[i].visible = true;
                    //}
                    if(i > -1 && i < 5) {
                        switch(i) {
                            case 0: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 1); break;
                            case 1: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 2); break;
                            case 2: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 3); break;
                            case 3: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 4); break;
                            case 4: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(4, 5); break;
                        }
                    }
                    else if(i > 4 && i < 10) {
                        switch(i) {
                            case 5: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 1); break;
                            case 6: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 2); break;
                            case 7: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 3); break;
                            case 8: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 4); break;
                            case 9: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(3, 5); break;
                        }
                    }
                    else if(i > 9 && i < 15) {
                        switch(i) {
                            case 10: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 1); break;
                            case 11: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 2); break;
                            case 12: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 3); break;
                            case 13: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 4); break;
                            case 14: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(2, 5); break;
                        }
                    }
                    else if(i > 14 && i <= 20) {
                        switch(i) {
                            case 15: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 1); break;
                            case 16: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 2); break;
                            case 17: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 3); break;
                            case 18: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 4); break;
                            case 19: WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 5);
                                WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore = 20;
                                WinterHoardGameModuleConfig.symbolDataStopped.isFilled = true;
                            break;
                            case 20:
                                //WinterHoardGameModuleConfig.indicatorBackground.fillMeterEnergy(1, 5);
                                WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore = 20;
                                WinterHoardGameModuleConfig.symbolDataStopped.isFilled = true;
                                [0, 1, 2, 3, 4].forEach((rid) => {
                                    [0, 1, 2 , 3].forEach((sid) => {
                                        const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                                        if(symbol && symbol.symName === "M1") {
                                            symbol.playNormalSpine();
                                        }
                                    });
                                });
                            break;
                        }
                    }


                    // TODO:
                    switch(i) {
                        case 4:
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(4, mode, symMps, fsLeft, isRestore);
                            //this._meters[0].getChildByName("M1").visible = true;
                            break;
                        case 9:
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(3, mode, symMps, fsLeft, isRestore);
                            //this._meters[1].getChildByName("M1").visible = true;
                            break;
                        case 14:
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(2, mode, symMps, fsLeft, isRestore);
                            //this._meters[2].getChildByName("M1").visible = true;
                            break;
                        case 19:
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(1, mode, symMps, fsLeft, isRestore);
                            WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0, mode, symMps, fsLeft, isRestore);
                            WinterHoardGameModuleConfig.symbolDataStopped.isFilled = true;
                            //WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0);
                            //this._meters[3].getChildByName("M1").visible = true;
                            break;
                        case 20:
                            //WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(1, mode, symMps, fsLeft, isRestore);
                            //WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0, mode, symMps, fsLeft, isRestore);
                            WinterHoardGameModuleConfig.symbolDataStopped.collectedBefore = 20;
                            WinterHoardGameModuleConfig.symbolDataStopped.isFilled = true;
                            [0, 1, 2, 3, 4].forEach((rid) => {
                                [0, 1, 2 , 3].forEach((sid) => {
                                    const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                                    if(symbol && symbol.symName === "M1") {
                                        symbol.playNormalSpine();
                                    }
                                });
                            });
                            //WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0);
                            //this._meters[3].getChildByName("M1").visible = true;
                            break;
                    }
                }, (isRestore)? 0 : "+=0.4");

                /*switch(WinterHoardGameModuleConfig.symbolData.level) {
                    case 1:
                        if(!isRestore && collectedBefore < 5) {
                            symMps.M5 = 2;//symMps.M5 + 1;
                            symMps.M1 = 2;//symMps.M1 + 1;
                        }

                        //this._meters[0].getChildByName("M1").visible = true;
                        break;
                    case 2:

                        if(!isRestore && collectedBefore < 10) {
                            symMps.M5 = 3;//symMps.M5 + 1;
                            symMps.M4 = 3;//symMps.M4 + 2;
                            symMps.M1 = 3;//symMps.M1 + 1;
                        }
                        //this._meters[1].getChildByName("M1").visible = true;
                        break;
                    case 3:

                        if(!isRestore && collectedBefore < 10) {
                            symMps.M5 = 3;//symMps.M5 + 1;
                            symMps.M4 = 3;//symMps.M4 + 2;
                            symMps.M1 = 3;//symMps.M1 + 1;
                        }
                        //this._meters[2].getChildByName("M1").visible = true;
                        break;
                    case 4:
                        if(!isRestore && collectedBefore < 15) {
                            symMps.M5 = 4;//symMps.M5 + 1;
                            symMps.M4 = 4;//symMps.M4 + 2;
                            symMps.M3 = 4;//symMps.M3 + 3;
                            symMps.M1 = 4;//symMps.M1 + 1;
                        }
                        break;
                }*/

                tlArr.push(tl);
            }
        }
        else if(energyCollectedAfter >= 20 && isRestore){
            WinterHoardGameModuleConfig.symbolDataStopped.symbolMultipliers = symbolMultipliers;
            /*for(let i = 0; i < WinterHoardGameModuleConfig.symbolDataStopped.level; i++) {
                WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(i, mode, symbolMultipliers);
            }*/

            if(energyCollectedAfter >= 20) {
                WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(4, mode, symbolMultipliers, fsLeft, isRestore);
                WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(3, mode, symbolMultipliers, fsLeft, isRestore);
                WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(2, mode, symbolMultipliers, fsLeft, isRestore);
                WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(1, mode, symbolMultipliers, fsLeft, isRestore);
                WinterHoardGameModuleConfig.indicatorBackground.fillSymIndicator(0, mode, symbolMultipliers, fsLeft, isRestore);
            }
        }


        if(!isRestore) {
            tlArr.push(new TimelineLite().add(() => {}, "+=0.5"));
        }

        //console.log("///////////---------------------> COLLECTED AFTER: " + collectedAfter);
        // TODO: ONLY UPDATE MULTIPLIER ON COLLECTED AFTER: 5, 10, 15, 20

        const symMps:{M1:number, M2:number, M3:number, M4:number, M5:number} = {
            M1: symbolMultipliers.M1 || 1,
            M2: symbolMultipliers.M2 || 1,
            M3: symbolMultipliers.M3 || 1,
            M4: symbolMultipliers.M4 || 1,
            M5: symbolMultipliers.M5 || 1,
        };
        const tlMp:TimelineLite = new TimelineLite({paused: false});


        // TODO: UPDATE of Extra FS shall not be here!
        if(energyCollectedBefore < energyCollectedAfter && energyCollectedAfter <= 35) {
            if(!isRestore) {
                tlMp.add(() => {
                }, (collectedAfter - collectedBefore) * 0.3);
            }

            switch (collectedAfter) {
                case 5:
                    if (!isRestore && collectedBefore < 5) {
                        symMps.M5 = 2;//symMps.M5 + 1;
                        symMps.M1 = 2;//symMps.M1 + 1;

                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        //console.log("MULTIPLIER FS PLAYED: " + fsPlayed + " COLLECTED: " + i + "  SYM MP:s INCREMENTED: " );
                        //console.log(symMps);
                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 6:
                if(!isRestore && collectedBefore < 5) {
                    symMps.M5 = 2;//symMps.M5 + 1;
                    symMps.M1 = 2;//symMps.M1 + 1;

                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        //console.log("MULTIPLIER FS PLAYED: " + fsPlayed + " COLLECTED: " + i + "  SYM MP:s INCREMENTED: " );
                        //console.log(symMps);
                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }

                    break;
                case 7:
                    if (!isRestore && collectedBefore < 5) {
                        symMps.M5 = 2;//symMps.M5 + 1;
                        symMps.M1 = 2;//symMps.M1 + 1;

                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        //console.log("MULTIPLIER FS PLAYED: " + fsPlayed + " COLLECTED: " + i + "  SYM MP:s INCREMENTED: " );
                        //console.log(symMps);
                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 8:
                    if (!isRestore && collectedBefore < 5) {
                        symMps.M5 = 2;//symMps.M5 + 1;
                        symMps.M1 = 2;//symMps.M1 + 1;

                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        //console.log("MULTIPLIER FS PLAYED: " + fsPlayed + " COLLECTED: " + i + "  SYM MP:s INCREMENTED: " );
                        //console.log(symMps);
                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 9:
                    if (!isRestore && collectedBefore < 5) {
                        symMps.M5 = 2;//symMps.M5 + 1;
                        symMps.M1 = 2;//symMps.M1 + 1;
                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        //console.log("MULTIPLIER FS PLAYED: " + fsPlayed + " COLLECTED: " + i + "  SYM MP:s INCREMENTED: " );
                        //console.log(symMps);
                        //console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 10:
                    if (!isRestore && collectedBefore < 10) {
                        symMps.M5 = 3;//symMps.M5 + 1;
                        symMps.M4 = 3;//symMps.M4 + 2;
                        symMps.M1 = 3;//symMps.M1 + 1;
                    }

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    break;
                case 11:
                    if (!isRestore && collectedBefore < 10) {
                        symMps.M5 = 3;//symMps.M5 + 1;
                        symMps.M4 = 3;//symMps.M4 + 2;
                        symMps.M1 = 3;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 12:
                    if (!isRestore && collectedBefore < 10) {
                        symMps.M5 = 3;//symMps.M5 + 1;
                        symMps.M4 = 3;//symMps.M4 + 2;
                        symMps.M1 = 3;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 13:
                    if (!isRestore && collectedBefore < 10) {
                        symMps.M5 = 3;//symMps.M5 + 1;
                        symMps.M4 = 3;//symMps.M4 + 2;
                        symMps.M1 = 3;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 14:
                    if (!isRestore && collectedBefore < 10) {
                        symMps.M5 = 3;//symMps.M5 + 1;
                        symMps.M4 = 3;//symMps.M4 + 2;
                        symMps.M1 = 3;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 15:
                    if (!isRestore && collectedBefore < 15) {
                        symMps.M5 = 4;//symMps.M5 + 1;
                        symMps.M4 = 4;//symMps.M4 + 2;
                        symMps.M3 = 4;//symMps.M3 + 3;
                        symMps.M1 = 4;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 16:
                if(!isRestore && collectedBefore < 15) {
                    symMps.M5 = 4;//symMps.M5 + 1;
                    symMps.M4 = 4;//symMps.M4 + 2;
                    symMps.M3 = 4;//symMps.M3 + 3;
                    symMps.M1 = 4;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 17:
                    if (!isRestore && collectedBefore < 15) {
                        symMps.M5 = 4;//symMps.M5 + 1;
                        symMps.M4 = 4;//symMps.M4 + 2;
                        symMps.M3 = 4;//symMps.M3 + 3;
                        symMps.M1 = 4;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 18:
                    if (!isRestore && collectedBefore < 15) {
                        symMps.M5 = 4;//symMps.M5 + 1;
                        symMps.M4 = 4;//symMps.M4 + 2;
                        symMps.M3 = 4;//symMps.M3 + 3;
                        symMps.M1 = 4;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 19:
                    if (!isRestore && collectedBefore < 15) {
                        symMps.M5 = 4;//symMps.M5 + 1;
                        symMps.M4 = 4;//symMps.M4 + 2;
                        symMps.M3 = 4;//symMps.M3 + 3;
                        symMps.M1 = 4;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 20:
                    if (!isRestore && collectedBefore < 20) {
                        symMps.M5 = 5;//symMps.M5 + 1;
                        symMps.M4 = 5;//symMps.M4 + 2;
                        symMps.M3 = 5;//symMps.M3 + 3;
                        symMps.M2 = 5;//symMps.M2 + 4;
                        symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 21:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 22:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 23:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 24:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;// symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 25:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 26:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 27:
                    if (!isRestore && collectedBefore < 20) {
                        symMps.M5 = 5;//symMps.M5 + 1;
                        symMps.M4 = 5;//symMps.M4 + 2;
                        symMps.M3 = 5;//symMps.M3 + 3;
                        symMps.M2 = 5;//symMps.M2 + 4;
                        symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 28:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 29:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 30:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 31:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 32:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 33:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;//symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                    tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                }
                break;
            case 34:
                if(!isRestore && collectedBefore < 20) {
                    symMps.M5 = 5;//symMps.M5 + 1;
                    symMps.M4 = 5;// symMps.M4 + 2;
                    symMps.M3 = 5;//symMps.M3 + 3;
                    symMps.M2 = 5;//symMps.M2 + 4;
                    symMps.M1 = 5;//symMps.M1 + 1;

                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
                case 35:
                    if (!isRestore && collectedBefore < 20) {
                        symMps.M5 = 5;//symMps.M5 + 1;
                        symMps.M4 = 5;//symMps.M4 + 2;
                        symMps.M3 = 5;//symMps.M3 + 3;
                        symMps.M2 = 5;//symMps.M2 + 4;
                        symMps.M1 = 5;//symMps.M1 + 1;
                        tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
                    }
                    break;
            }
        }

        if(!isRestore && collectedBefore < 20 && collectedAfter >= 35) {
            //console.log("MULTIPLIER END CASE!");
            symMps.M5 = 5;//symMps.M5 + 1;
            symMps.M4 = 5;//symMps.M4 + 2;
            symMps.M3 = 5;//symMps.M3 + 3;
            symMps.M2 = 5;//symMps.M2 + 4;
            symMps.M1 = 5;//symMps.M1 + 1;
            tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, symMps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, isRestore));
        }

        if(isRestore) {
            //debugger;
            let restSymps: {M1:number,M2:number,M3:number,M4:number,M5:number} = {
                M1: 1,
                M2: 1,
                M3: 1,
                M4: 1,
                M5: 1
            };
            //symMps.M5 = 5;//symMps.M5 + 1;
            //symMps.M4 = 5;//symMps.M4 + 2;
            //symMps.M3 = 5;//symMps.M3 + 3;
            //symMps.M2 = 5;//symMps.M2 + 4;
            //symMps.M1 = 5;//symMps.M1 + 1;
            //debugger;
            if(energyCollectedAfter >= 5 && energyCollectedAfter < 10) {
                restSymps.M1 = 2;//symMps.M1 + 1;
                restSymps.M2 = 1;
                restSymps.M3 = 1;
                restSymps.M4 = 1;
                restSymps.M5 = 2;
            }
            else if(energyCollectedAfter >= 10 && energyCollectedAfter < 15) {
                restSymps.M1 = 3;//symMps.M1 + 1;
                restSymps.M2 = 1;
                restSymps.M3 = 1;
                restSymps.M4 = 3;
                restSymps.M5 = 3;
            }
            else if(energyCollectedAfter >= 15 && energyCollectedAfter < 20) {
                restSymps.M1 = 4;//symMps.M1 + 1;
                restSymps.M2 = 1;
                restSymps.M3 = 4;
                restSymps.M4 = 4;
                restSymps.M5 = 4;
            }
            else if(energyCollectedAfter >= 20) {
                restSymps.M5 = 5;//symMps.M5 + 1;
                restSymps.M4 = 5;//symMps.M4 + 2;
                restSymps.M3 = 5;//symMps.M3 + 3;
                restSymps.M2 = 5;//symMps.M2 + 4;
                restSymps.M1 = 5;//symMps.M1 + 1;
            }
            tlMp.add(WinterHoardGameModuleConfig.indicatorBackground.updateAndShowMultiplier(mode, restSymps, fsLeft, WinterHoardGameModuleConfig.symbolDataStopped.level, true));
        }
        /*
            TODO: ??????
            {M5: NaN, M1: NaN}
            SERVER:
            {M5: NaN, M1: NaN}

         */

        /*console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");
        console.log("MULTIPLIER FS PLAYED: " + fsPlayed + " COLLECTED: " + collectedAfter + "  SYM MP:s INCREMENTED: " );
        console.log(symMps);
        console.log("SYMBOL MULTIPLIERS SERVER: ");
        console.log(symbolMultipliers);
        console.log("/////////////////////////// FS MULTIPLIER /////////////////////////////////");*/

        tlArr.push(tlMp);

        return tlArr;
    }

    public update(reelId:number, sound:boolean = false):TimelineLite {
        const data:WinterHoardParsedGameData = <WinterHoardParsedGameData>SlotGame.model.gameData;

        const tl:TimelineLite = new TimelineLite(); //this._counters[reelId].update(data.scattersCollected[reelId]);

        if (sound && tl.duration() > 0){
            //tl.add(()=>SoundPlayer.playEffect(WinterHoardSoundConfig.SCATTER_COUNTER_UP));
        }

        return tl;
    }

    public updateAll():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        //for(let i:number = 0; i < this._counters.length; i++) {
        //tl.add(this.update(i), 0);
        //}
        return tl;
    }

    public show() {
        //this.visible = true;
        //StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_COUNTERS.name).addChild(this);
        WinterHoardGameModuleConfig.indicatorBackground.activateEnteringFS();
    }

    public hide() {
        this.visible = false;
        this._meters.forEach((sprite) => {
            sprite.getChildByName("M1").visible = false;
        });

        this._indicatorSprites.forEach((indicator) => {
            indicator.visible = false;
        });
        WinterHoardGameModuleConfig.indicatorBackground.deactivateExitingFS();
        //StageManager.getLayer(WinterHoardLayerConfig.FREESPIN_COUNTERS.name).removeChild(this);
    }
}